export default {
      id: "aurus-usage",
      viewBox: "0 0 100 26",
      url: "assets/" + "sprite.svg#aurus-usage",
      toString: function () {
        return this.url;
      }
    }